import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../style/CarsInfoPage.css';

const insuranceCompanies = [
    { name: 'ALFA Insurance', tariff: '1 200 000 UZS' },
    { name: 'UZAGRO SUGURTA', tariff: '1 350 000 UZS' },
    { name: 'GROSS Insurance', tariff: '1 150 000 UZS' },
];

const CarsInfoPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { brand, model, year } = location.state || {};
    const [step, setStep] = useState(0);

    const [formData, setFormData] = useState({
        carNumber: '',
        techPassport: '',
        ownerPassport: '',
        applicantPhone: '',
    });

    const handleNext = () => {
        // Проверки на заполнение данных
        if (step === 1 && (!formData.carNumber || !formData.techPassport)) {
            alert('Заполните номер машины и техпаспорт!');
            return;
        }
        if (step === 2 && !formData.ownerPassport) {
            alert('Введите паспорт владельца!');
            return;
        }
        if (step === 3 && !formData.applicantPhone) {
            alert('Введите номер телефона заявителя!');
            return;
        }

        setStep(prev => prev + 1);
    };

    const handleBack = () => {
        if (step === 0) {
            navigate('/');
        } else {
            setStep(prev => prev - 1);
        }
    };

    const renderInsuranceList = () => (
        <div className="insurance-list">
            <h3>📋 Доступные страховые фирмы</h3>
            {insuranceCompanies.map((company, idx) => (
                <div key={idx} className="insurance-item">
                    <strong>{company.name}</strong>
                    <p>💸 Тариф: {company.tariff}</p>
                    <button className="select-btn">Выбрать</button>
                </div>
            ))}
        </div>
    );

    const renderStepContent = () => {
        switch (step) {
            case 0:
                return (
                    <>
                        <h2>🚗 Информация о выбранном авто</h2>
                        <div className="info-block">
                            <p><strong>Марка:</strong> {brand}</p>
                            <p><strong>Модель:</strong> {model}</p>
                            <p><strong>Год выпуска:</strong> {year}</p>
                        </div>
                        {renderInsuranceList()}
                        <button className="continue-btn" onClick={handleNext}>
                            Перейти к заполнению →
                        </button>
                    </>
                );
            case 1:
                return (
                    <>
                        <h2>🚘 Данные авто</h2>
                        <input
                            type="text"
                            placeholder="Номер машины (например, 10A123AA)"
                            value={formData.carNumber}
                            onChange={e => setFormData({ ...formData, carNumber: e.target.value })}
                        />
                        <input
                            type="text"
                            placeholder="Серия и номер техпаспорта (например, ABC1234567)"
                            value={formData.techPassport}
                            onChange={e => setFormData({ ...formData, techPassport: e.target.value })}
                        />
                        <button className="continue-btn" onClick={handleNext}>Дальше</button>
                    </>
                );
            case 2:
                return (
                    <>
                        <h2>👤 Владелец авто</h2>
                        <input
                            type="text"
                            placeholder="Серия и номер паспорта"
                            value={formData.ownerPassport}
                            onChange={e => setFormData({ ...formData, ownerPassport: e.target.value })}
                        />
                        <button className="continue-btn" onClick={handleNext}>Дальше</button>
                    </>
                );
            case 3:
                return (
                    <>
                        <h2>📞 Заявитель</h2>
                        <input
                            type="text"
                            placeholder="Номер телефона"
                            value={formData.applicantPhone}
                            onChange={e => setFormData({ ...formData, applicantPhone: e.target.value })}
                        />
                        <button className="continue-btn" onClick={handleNext}>Готово</button>
                    </>
                );
            case 4:
                return (
                    <div className="thank-you">
                        <h2>✅ Спасибо!</h2>
                        <p>Все данные успешно заполнены.</p>
                        <button onClick={() => navigate('/')}>На главную</button>
                    </div>
                );
            default:
                return null;
        }
    };

    const renderStepsBar = () => {
        const steps = ['Инфо и страховка', 'Данные авто', 'Владелец авто', 'Заявитель', 'Готово'];
        return (
            <div className="steps">
                {steps.map((label, index) => (
                    <div key={label} className={`step ${index === step ? 'active' : ''}`}>
                        <span>{index}</span>
                        <p>{label}</p>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="eosago-page">
            <main>
                {renderStepsBar()}
                <section className="data-block">
                    {renderStepContent()}
                    {step > 0 && step < 4 && (
                        <p className="agreement">
                            Нажимая «Продолжить», вы соглашаетесь с офертой и даёте согласие на обработку персональных данных.
                        </p>
                    )}
                    {step > 0 && (
                        <button className="back-btn" onClick={handleBack}>
                            ← Назад
                        </button>
                    )}
                </section>
            </main>
        </div>
    );
};

export default CarsInfoPage;
